import { Button, Flex, Image } from '@chakra-ui/react'

import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { PaginationProps } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import ArrowLeft from '../../images/arrowLeft.svg'
import ArrowRight from '../../images/arrowRight.svg'

const Page = ({ pageNumber, isCurrent, onClick }: { pageNumber: number; isCurrent: boolean, onClick: (page: number) => void }) => {
  return (
    <Button
      type="button"
      onClick={() => onClick(pageNumber)}
      variant={isCurrent ? 'solid' : 'ghost'}
      colorScheme={isCurrent ? 'primary' : 'white'}
    >
      {pageNumber}
    </Button>
  )
}

// generovani pole hodnot od - do s krokem
const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step))

export const Pagination = ({
  totalCount,
  currentPage,
  maxButtonCount = 5,
  pageSize = 10,
  setCurrentPage,
  pagesProps,
  countProps,
  textAfterNumberOfRecords
}: PaginationProps) => {
  const { translate } = useTranslationsContext()

  // celkovy pocet stranek
  const totalPagesCount = pageSize > 0 ? Math.ceil(totalCount / pageSize) : 1

  // pokud je stránek mene nez tlacitek, tak zmensime jejich pocet
  if (maxButtonCount > totalPagesCount) maxButtonCount = totalPagesCount

  // zjisteni na jakem cisle ma strankovani zrovna zacit a na jakem koncit
  const startPage = Math.floor(currentPage - ((maxButtonCount / 2) - 1))
  let start = startPage < 1 ? 1 : startPage
  let end = start + maxButtonCount - 1

  if (end > totalPagesCount) {
    end = totalPagesCount
    start = totalPagesCount - maxButtonCount + 1
    start = start < 1 ? 1 : start
  }

  // vygenerovani tlacitek
  const pages = range(start, end, 1)

  return (
    <>
      {/* <Flex sx={{ w: '100%', gap: 1, justifyContent: 'space-between' }}> */}
      {/* <Flex >TODO: editovat počet záznamů na stránku</Flex> */}

      <Flex justifyContent='center' {...pagesProps}>
        {start > 1 && <Button variant='ghost' colorScheme='white' onClick={() => setCurrentPage(currentPage - 1)} ><Image src={ArrowLeft} /></Button>}
        {pages &&
          pages.length > 1 &&
          pages.map((page) =>
            <Page key={page} pageNumber={page} isCurrent={page === currentPage} onClick={setCurrentPage} />
          )
        }
        {end < totalPagesCount && <Button variant='ghost' colorScheme='white' onClick={() => setCurrentPage(currentPage + 1)}><Image src={ArrowRight} /></Button>}
      </Flex>

      <Flex my={2} justifyContent='flex-end' {...countProps} fontSize={'sm'}>
        {translate('total', 'Celkem')} {totalCount} {totalCount == 1 ? translate('record1', 'záznam') : (totalCount < 5 && totalCount != 0 ? translate('record2', 'záznamy') : translate('record5', 'záznamů'))} {textAfterNumberOfRecords}
      </Flex>
      {/* </Flex > */}
    </>
  )
}
